// @ts-nocheck

import { createSelector } from 'reselect';

import { getEventCenterConfig } from '../../constants/eventCenter';
import { getCategoryIdFromProps, getSportIdFromProps } from '../../selectors/_propsGetters_';
import {
  selectEntitiesMatchesEntityImgEventId,
  selectEntitiesMatchesEntityImgFightId,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { createResultEqualSelector } from '../../utils/reselect';

const selectConfig = createResultEqualSelector(
  [
    getSportIdFromProps,
    getCategoryIdFromProps,
    selectEntitiesMatchesEntityImgEventId,
    selectEntitiesMatchesEntityImgFightId,
  ],
  (sportId, categoryId, eventId, fightId) => {
    if (sportId) {
      const config = getEventCenterConfig(sportId, categoryId);

      if (config) {
        if (fightId) {
          config.initialContext = {
            ...(config.initialContext ?? {}),
            fightId: `${fightId}`,
          };
        }

        if (eventId) {
          return {
            ...config,
            eventId: `${eventId}`,
          };
        }
      }
    }
  },
);

const selectEventCenterNodeProps = createSelector([selectConfig], (config) => ({
  config,
}));

export default selectEventCenterNodeProps;
